/** @format */

import { ListingFilters } from '@/@ducks/listing/types';

export const utilityGTMBuildStringByListingActiveFilters = (filters: ListingFilters) => {
  const { amenities, facilities, propertyType, monthlyPrice, suitability, checkInDate, positions, districts } = filters;

  const filtersToSend = [];

  Object.values(amenities).some(Boolean) && filtersToSend.push('amenities');
  Object.values(facilities).some(Boolean) && filtersToSend.push('facilities');
  Object.values(suitability).some(Boolean) && filtersToSend.push('suitability');
  (monthlyPrice.min || monthlyPrice.max) && filtersToSend.push('price_range');
  Object.values(propertyType).some(Boolean) && filtersToSend.push('property_type');
  checkInDate.length > 0 && filtersToSend.push('check_in_date');
  positions && positions.length > 0 && filtersToSend.push('points_of_interest');
  districts && districts.length > 0 && filtersToSend.push('districts');

  return filtersToSend.join('|');
};
